import { fmtMultiplier } from '../shared/formatters'

const COVERAGE_MAX_MONTHS = 24;

const simulateCoverageMonths = ({ startStock, startIndex, salesAt }) => {
  if (startStock <= 0) return 0;

  let remaining = startStock;
  let coverage = 0;

  for (let offset = 0; offset < COVERAGE_MAX_MONTHS; offset++) {
    const sales = salesAt(startIndex + offset);

    if (sales == null) continue;

    if (sales <= 0) {
      coverage += 1;
      continue;
    }

    if (remaining >= sales) {
      remaining -= sales;
      coverage += 1;
      continue;
    }

    return coverage + remaining / sales;
  }

  return coverage;
};

const buildSalesAtIndex = (plannedSalesRaw) => (index) => {
  let wrappedIndex = index;

  while (wrappedIndex >= plannedSalesRaw.length) wrappedIndex -= 12;

  return wrappedIndex >= 0 ? plannedSalesRaw[wrappedIndex] : null;
};

export const buildCoverageValues = ({
  monthKeys,
  currentMonthKey,
  finalStockRaw,
  plannedSalesRaw,
  pastCoverageValues,
}) => {
  const salesAt = buildSalesAtIndex(plannedSalesRaw);

  return finalStockRaw.map((stock, i) => {
    if (monthKeys[i] < currentMonthKey) return pastCoverageValues[i] ?? null;
    if (stock == null) return null;

    return fmtMultiplier(simulateCoverageMonths({ startStock: stock, startIndex: i, salesAt }));
  });
};